import { render, staticRenderFns } from "./GoodslistBody.vue?vue&type=template&id=8a7b2c76&scoped=true&"
import script from "./GoodslistBody.vue?vue&type=script&lang=js&"
export * from "./GoodslistBody.vue?vue&type=script&lang=js&"
import style0 from "./GoodslistBody.vue?vue&type=style&index=0&id=8a7b2c76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7b2c76",
  null
  
)

export default component.exports